if (!customElements.get('clipboard-copy')) {
  class ClipboardCopy extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('click', (event) => {
        event.preventDefault();

        navigator.clipboard.writeText(window.location.href).then(() => {
          document.dispatchEvent(new CustomEvent('toast:show', { detail: { text: this.getAttribute('data-success-message') }}));
        },
        (err) => {
          document.dispatchEvent(new CustomEvent('toast:show', { detail: { text: err }}));
        });
      });
    }
  }

  customElements.define('clipboard-copy', ClipboardCopy);
}
